import React from 'react';
import { useForm, usePage } from '@inertiajs/inertia-react';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import classNames from 'classnames';
import Layout from '../../Shared/Layout/LayoutAdmin';
import Breadcrumbs from '../../Shared/Components/Breadcrumbs';

const Add = () => {
    const { data, setData, post, processing, errors } = useForm({
        name: '',
        min_monthly_premium: '',
        max_monthly_premium: '',
        commission_percent: '',
        additional_percent: '0',
        active: 1,
        sort_order: 0
    });

    const { errors: pageErrors } = usePage().props;
    const formErrors = Object.keys(errors || {}).length ? errors : (pageErrors || {});

    const submit = e => {
        e.preventDefault();
        post(route('advisor_commission_tiers.store'));
    };

    return (
        <Row>
            <span className="p-7">
                <Breadcrumbs currentPath="/admin/master_data/advisor-commission-tiers/add" />
            </span>
            <h2>Agregar Nivel</h2>
            <Form onSubmit={submit}>
                <Form.Group className="mb-3">
                    <Form.Label>Categoría</Form.Label>
                    <Form.Control
                        className={classNames({ 'is-invalid': formErrors.name })}
                        value={data.name}
                        onChange={e => setData('name', (e.target.value || '').toUpperCase())}
                    />
                    {formErrors.name && <div className="text-danger mt-2">{formErrors.name}</div>}
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Prima Mensual Mínima</Form.Label>
                    <Form.Control
                        type="number" step="0.01" min="0"
                        className={classNames({ 'is-invalid': formErrors.min_monthly_premium })}
                        value={data.min_monthly_premium}
                        onChange={e => setData('min_monthly_premium', e.target.value)}
                    />
                    {formErrors.min_monthly_premium && <div className="text-danger mt-2">{formErrors.min_monthly_premium}</div>}
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Prima Mensual Máxima</Form.Label>
                    <Form.Control
                        type="number" step="0.01" min="0"
                        className={classNames({ 'is-invalid': formErrors.max_monthly_premium })}
                        value={data.max_monthly_premium}
                        onChange={e => setData('max_monthly_premium', e.target.value)}
                    />
                    {formErrors.max_monthly_premium && <div className="text-danger mt-2">{formErrors.max_monthly_premium}</div>}
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>% Comisión</Form.Label>
                    <Form.Control
                        type="number" step="0.01" min="0" max="100"
                        className={classNames({ 'is-invalid': formErrors.commission_percent })}
                        value={data.commission_percent}
                        onChange={e => setData('commission_percent', e.target.value)}
                    />
                    {formErrors.commission_percent && <div className="text-danger mt-2">{formErrors.commission_percent}</div>}
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>% Adicional</Form.Label>
                    <Form.Control
                        type="number" step="0.01" min="0" max="100"
                        className={classNames({ 'is-invalid': formErrors.additional_percent })}
                        value={data.additional_percent}
                        onChange={e => setData('additional_percent', e.target.value)}
                    />
                    {formErrors.additional_percent && <div className="text-danger mt-2">{formErrors.additional_percent}</div>}
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Activo?</Form.Label>
                    <Form.Select
                        className={classNames({ 'is-invalid': formErrors.active })}
                        value={data.active}
                        onChange={e => setData('active', e.target.value)}
                    >
                        <option value="1">Sí</option>
                        <option value="0">No</option>
                    </Form.Select>
                    {formErrors.active && <div className="text-danger mt-2">{formErrors.active}</div>}
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Orden</Form.Label>
                    <Form.Control
                        type="number" min="0"
                        className={classNames({ 'is-invalid': formErrors.sort_order })}
                        value={data.sort_order}
                        onChange={e => setData('sort_order', e.target.value)}
                    />
                    {formErrors.sort_order && <div className="text-danger mt-2">{formErrors.sort_order}</div>}
                </Form.Group>
                <Button disabled={processing} type="submit" className="me-3">Guardar</Button>
                <Button variant="secondary" onClick={() => window.history.back()}>Regresar</Button>
            </Form>
        </Row>
    );
};

Add.layout = page => <Layout children={page} title="Agregar Nivel" />;
export default Add;
